export type InvestorProgramFields = {
  complianceProgram?: string | null;
  isInvestorDiligenceEnabled: boolean;
  fatcaCrsEnabled: boolean;
};

export const formatInvestorProgram = ({
  complianceProgram,
  isInvestorDiligenceEnabled,
  fatcaCrsEnabled,
}: InvestorProgramFields): string => {
  const primary = complianceProgram
    ? complianceProgram
    : isInvestorDiligenceEnabled
      ? "Legacy KYC"
      : "--";
  if (!fatcaCrsEnabled) {
    return primary;
  }
  return `${primary}, FATCA/CRS`;
};
